export const CLEAR_SCHOOL_DETAIL = 'CLEAR_SCHOOL_DETAIL';
export const START_FETCH_SCHOOL_DETAIL = 'START_FETCH_SCHOOL_DETAIL'
export const SUCCESS_FETCH_SCHOOL_DETAIL = 'SUCCESS_FETCH_SCHOOL_DETAIL'
export const FAILED_FETCH_SCHOOL_DETAIL = 'FAILED_FETCH_SCHOOL_DETAIL'
export const UPDATE_SCHOOL_INFO = 'UPDATE_SCHOOL_INFO'

import getSchoolDetailCTRL from 'controllers/school/getSchoolDetail';

export function clearSchoolDetail() {
  return function (dispatch) {
    dispatch({
      type: CLEAR_SCHOOL_DETAIL,
    });
  }
}
export function updateSchoolInfo(updatedInfo) {
  return function (dispatch) {
    dispatch({
      type: UPDATE_SCHOOL_INFO,
      payload: updatedInfo
    });
  }
}
export function fetchSchoolDetail(schoolId, callback){

  return function(dispatch) {

    dispatch({
      type: START_FETCH_SCHOOL_DETAIL,
      payload: {fetching: true}
    })

    getSchoolDetailCTRL(schoolId)
    .then((result) => {
      dispatch({
        type: SUCCESS_FETCH_SCHOOL_DETAIL,
        payload: {...result, fetching: false}
      })

      if(typeof(callback) == 'function'){
        callback()
      }

    })
    .catch((err)  => {
      dispatch({
        type: FAILED_FETCH_SCHOOL_DETAIL,
        payload: err
      })
    })
  }
}

const initState = {
  detail: {}
}

export default function schoolDetail(state = initState, action){
  
  switch(action.type){
    case START_FETCH_SCHOOL_DETAIL: {
      return {...state, ...action.payload}
    }
    case SUCCESS_FETCH_SCHOOL_DETAIL: {
      return {...state, detail: action.payload}
    }
    case FAILED_FETCH_SCHOOL_DETAIL: {
      return {...state, err: action.payload}
    }
    case UPDATE_SCHOOL_INFO: {
      return { ...state, detail: action.payload}
    }
    case CLEAR_SCHOOL_DETAIL: {
      localStorage.removeItem('schoolId');
      return {...state, detail: {} }
    }

    default: return {...state}
  }
}



// WEBPACK FOOTER //
// ./src/containers/Main/ducks/school-detail.js